import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { handleRequest } from "@utils/http-util";
import { WorkflowConfiguration } from "@idw-types/data/workflow-configuration";

export const getWorkflowConfigurationsRequest = async (): Promise<{ data: Array<WorkflowConfiguration>, error: any }> => {
    const route = apiRoutes.serviceConfiguration.workflows;
    const { data, error } = await handleRequest(RequestTypes.GET, route);
    return { data, error };
};